import { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Button } from '@mui/joy';
import { motion, AnimatePresence } from 'framer-motion';
import UndoRoundedIcon from '@mui/icons-material/UndoRounded';

export default function UndoToast({ message, timeout = 10000, onUndo, onExpire, visible }) {
    const [remaining, setRemaining] = useState(timeout);

    useEffect(() => {
        if (!visible) { setRemaining(timeout); return; }

        setRemaining(timeout);
        const start = Date.now();
        const interval = setInterval(() => {
            const elapsed = Date.now() - start;
            const left = timeout - elapsed;
            if (left <= 0) {
                clearInterval(interval);
                setRemaining(0);
                onExpire?.();
            } else {
                setRemaining(left);
            }
        }, 100);

        return () => clearInterval(interval);
    }, [visible, timeout]); // eslint-disable-line

    const progress = remaining / timeout;

    return (
        <AnimatePresence>
            {visible && remaining > 0 && (
                <motion.div
                    initial={{ opacity: 0, y: 30, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 30, scale: 0.95 }}
                    transition={{ duration: 0.25 }}
                    style={{
                        position: 'fixed', bottom: 24, left: '50%',
                        transform: 'translateX(-50%)', zIndex: 10000,
                    }}
                >
                    <Box sx={{
                        display: 'flex', alignItems: 'center', gap: 2,
                        bgcolor: 'var(--joy-palette-background-level2)',
                        border: '1px solid var(--joy-palette-divider)',
                        borderRadius: 'var(--joy-radius-xl)',
                        px: 2.5, py: 1.5,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
                        position: 'relative', overflow: 'hidden',
                    }}>
                        {/* Прогресс-бар */}
                        <Box sx={{
                            position: 'absolute', bottom: 0, left: 0,
                            height: 3, width: `${progress * 100}%`,
                            bgcolor: 'var(--joy-palette-primary-500)',
                            transition: 'width 0.1s linear',
                            borderRadius: '0 0 0 var(--joy-radius-xl)',
                        }} />

                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'var(--joy-palette-text-primary)', whiteSpace: 'nowrap' }}>
                            {message}
                        </Typography>

                        <Button
                            size="sm" variant="soft" color="primary"
                            startDecorator={<UndoRoundedIcon sx={{ fontSize: 14 }} />}
                            onClick={() => onUndo?.()}
                            sx={{ fontWeight: 700, fontSize: 12, flexShrink: 0 }}
                        >
                            Отменить ({Math.ceil(remaining / 1000)})
                        </Button>
                    </Box>
                </motion.div>
            )}
        </AnimatePresence>
    );
}